module.exports = function () {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var keysA = Object.keys(a);
  var keysB = new Set(Object.keys(b));
  return !keysA.some(function (ka) {
    return keysB.has(ka);
  });
};